import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState'
import { ConceptDayComment } from '../../entities/Comment/Comment'

export type ConceptDayCommentsState = AsyncReduxState<{
    conceptDayComments?: ConceptDayComment[];
}>;

const initialState: ConceptDayCommentsState = {
    ...initialAsyncReduxState,
}

export const conceptDayCommentsSlice = createSlice({
    name: 'conceptDayCommentsReducer',
    initialState,
    reducers: {
        setConceptDayComments(state, action: PayloadAction<ConceptDayComment[] | undefined>): ConceptDayCommentsState {
            return {
                ...state,
                conceptDayComments: action.payload,
            }
        },
        setIsLoading(state, action: PayloadAction<boolean>): ConceptDayCommentsState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ConceptDayCommentsState {
            return {
                ...state,
                isSuccessful: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): ConceptDayCommentsState {
            return {
                ...state,
                error: action.payload,
            }
        },
    },
})

export const {
    setIsLoading,
    setError,
    setIsSuccessful,
    setConceptDayComments,
} = conceptDayCommentsSlice.actions

export default conceptDayCommentsSlice.reducer
